import { Box, Stack } from "@mui/material";
import React from "react";

import { CustomModal } from "new-components/modals/CustomModal";
import { Typography } from "new-components/typography/Typography";
import { Detector } from "types/detectors";

import { NotesContent } from "./NotesContent";

export interface NotesModalProps {
  detector: Detector;
  openModal: boolean;
  onClose: () => void;
  ownerGroupId: string | undefined;
  ownerGroupName: string | undefined;
}

export function NotesModal(props: NotesModalProps) {
  const { detector, openModal, onClose, ownerGroupId, ownerGroupName } = props;

  return (
    <CustomModal
      open={openModal}
      onClose={onClose}
      size="fullScreen"
      title={`${detector.name} - Notes`}
      titleAlignment="left"
      body={
        <Box py="20px" width="100%">
          <Stack direction="row" pb="10px" gap={1}>
            <Typography variant="title" sx={{ color: "#0450BA" }}>
              Query:
            </Typography>
            <Typography variant="title">{detector.label_prompt}</Typography>
          </Stack>

          <NotesContent ownerGroupId={ownerGroupId} ownerGroupName={ownerGroupName} detector={detector} />
        </Box>
      }
    />
  );
}
